export default __webpack_public_path__ + "static/media/GEOMETER_BLANK.1730f494.jpg";